import React from "react";
import { useParams, Link } from "react-router-dom";

import blog1 from "../assets/blog1.png";
import blog2 from "../assets/blog2.png";
import blog3 from "../assets/blog3.png";

const BlogDetail = () => {
  const { id } = useParams();

  const blogs = {
    "future-web-dev": {
      title: "The Future of Web Development",
      img: blog1,
      content: `
The world of web development is evolving faster than ever.

Technologies like AI, Web3, and serverless architecture are changing how applications are built.

Modern developers are focusing on:
- Performance optimization
- Scalable systems
- Better user experiences

Frameworks like React and Next.js are leading this transformation.

Businesses that adapt early will dominate the digital space.
      `,
    },

    "ui-ux-importance": {
      title: "Why UI/UX Matters More Than Ever",
      img: blog2,
      content: `
UI/UX plays a crucial role in digital success.

Users judge your brand within seconds based on design.

Key principles include:
- Simplicity
- Clarity
- Accessibility

A good design increases trust, engagement, and conversions.

Design is not just visual — it's functional.
      `,
    },

    "seo-strategies": {
      title: "SEO Strategies That Actually Work",
      img: blog3,
      content: `
SEO is essential for visibility in today's digital world.

Effective strategies include:
- High-quality content
- Keyword optimization
- Fast-loading pages
- Mobile responsiveness

Search engines prioritize user experience.

Focus on value, and rankings will follow.
      `,
    },
  };

  const blog = blogs[id];

  if (!blog) {
    return (
      <div className="text-white text-center mt-20">
        <h1 className="text-3xl">Blog Not Found</h1>
        <Link to="/blog" className="text-purple-400 underline mt-4 block">
          Go Back
        </Link>
      </div>
    );
  }

  return (
    <div className="text-white bg-black min-h-screen">

      {/* HERO IMAGE */}
      <div className="h-[60vh] relative">
        <img
          src={blog.img}
          alt={blog.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/70"></div>

        <div className="absolute bottom-10 left-6 md:left-20 max-w-3xl">
          <h1 className="text-3xl md:text-5xl font-bold">
            {blog.title}
          </h1>
        </div>
      </div>

      {/* CONTENT */}
      <div className="max-w-4xl mx-auto px-6 py-16">
        <p className="text-gray-300 leading-relaxed whitespace-pre-line text-lg">
          {blog.content}
        </p>

        <Link
          to="/blog"
          className="inline-block mt-10 text-purple-400 hover:underline"
        >
          ← Back to Blogs
        </Link>
      </div>

    </div>
  );
};

export default BlogDetail;